// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WK-z","twoColumnImage":"XK-z"};